// @ts-nocheck
import _ from 'lodash';
import { httpClient } from '../../../core/network';

class OrderService {
  static fetchOrders(customerId, orderStatus = 'all', pageNr = 1, pageSize = 20) {
    const apiUrl = '/orders';
    return httpClient.get(apiUrl, {
      params: {
        customerId,
        orderStatus,
        pageNr,
        pageSize,
      },
    });
  }

  static fetchOrder(orderId, type) {
    const apiUrl = `/orders/${orderId}`;
    return httpClient.get(apiUrl, {
      params: { type },
    });
  }

  static refundOrder(userId, orderId, amount) {
    const orderData = {
      amount: _.toNumber(amount.replace(/[^0-9]/g, '')),
      description: 'Refunderet af Kundeservice',
    };

    const apiUrl = `/users/${userId}/orders/${orderId}/refund`;
    return httpClient.post(apiUrl, orderData);
  }

  static cancelOrder(userId, orderId) {
    const apiUrl = `/users/${userId}/orders/${orderId}`;
    return httpClient.delete(apiUrl);
  }
}

export default OrderService;
